import * as React from "react";
import { styled } from "@mui/material";
import { PatientColorMap } from "../../layout/patientColorMap";

//region [[ Styles ]]

const RoundedPatientTitleBoxView = styled("div")({
  marginTop: "20px",
  border: "1px solid #EBEBEB",
  boxShadow: "0px 7px 17px rgba(0, 0, 0, 0.05)",
  borderRadius: "8px",
  padding: "20px",
  paddingTop: 0,
  marginBottom: "41%",
});

const BoxTitle = styled("div")({
  background: PatientColorMap.Primary,
  padding: "17px 12px",
  fontWeight: 700,
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: PatientColorMap.White,
  margin: "10px -20px",
  marginTop: 0,
  textAlign: "center",
  borderTopRightRadius: "8px",
  borderTopLeftRadius: "8px",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RoundedPatientTitleBoxProps {
  className?: string;
  children: React.ReactNode;
  title: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RoundedPatientTitleBox = ({
  ...props
}: RoundedPatientTitleBoxProps) => {
  return (
    <RoundedPatientTitleBoxView className={props.className}>
      <BoxTitle>{props.title}</BoxTitle>
      {props.children}
    </RoundedPatientTitleBoxView>
  );
};
